<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container class="px-6">
    <v-progress-linear
      v-if="mainPageLoading"
      color="primary"
      indeterminate
    />
    <page-header>{{ $t('staff') }}</page-header>
    <div
      class="mt-4"
      style="
      display: grid;
      grid-template-columns: repeat(4,minmax(0,1fr));
      grid-gap: 16px;
      grid-auto-rows:360px ;"
    >
      <v-card
        class="pa-4 d-flex align-center justify-center"
        color="#eee"
        elevation="0"
        height="360"
        @click="editItem(-1)"
      >
        <div class="text-center">
          <v-icon size="48">
            mdi-plus
          </v-icon>
          <div>
            {{ $t('addNewStaff') }}
          </div>
        </div>
      </v-card>
      <v-card
        v-for="(s,index) in localServantList"
        :key="s.servant.id"
        class="text-body-1"
        elevation="0"
        style="overflow: visible;"
        @click="changeActiveId(s,index)"
      >
        <v-card
          :class="activeId===s.servant.id?'elevation-1':''"
          class="pa-4"
          outlined
          style="border-radius: 16px;min-height: 360px"
        >
          <div class="d-flex justify-space-between align-center">
            <div class="text-h4 font-weight-bold">
              {{ s.servant.name }}
            </div>
            <v-menu
              close-on-content-click
              left
              offset-overflow
              offset-y
              rounded
            >
              <template #activator="{on,attrs}">
                <v-btn
                  icon
                  outlined
                  style="border-radius: 12px"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list
                outlined
                width="200px"
              >
                <v-list-item-group>
                  <v-list-item @click="printServantSummary(s.servant.password)">
                    <v-list-item-title>{{ $t('printDailyOrder') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="editItem(index)">
                    <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="startPowerManage(s.servant)">
                    <v-list-item-title
                      class="hiddenText"
                    >
                      {{ $t('editStaffPower') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteItem(s.servant.id)">
                    <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
          <div
            v-if="s.todayTotal>0"
          >
            <div class="text-body-2 mt-4">
              <div
                v-for="pay in fillPayMethodTotal(s.payMethodTotal,true)"
                :key="pay.id"
                class="d-flex justify-space-between pt-1"
              >
                <div>
                  {{ $t(pay.name) }}
                </div>
                <div class="value font-weight-bold">
                  {{ pay.amount | priceDisplay }}
                </div>
              </div>
              <div
                class="d-flex justify-start py-1"
              >
                <div
                  v-if="activeId!==s.servant.id"
                  style="border-bottom: 1px solid #4D8AED;color: #4D8AED"
                >
                  {{ $t('showMore') }}
                </div>
                <div
                  v-else
                  style="border-bottom: 1px solid #4D8AED;color: #4D8AED"
                >
                  {{ $t('packUp') }}
                </div>
              </div>
            </div>
            <v-divider class="my-2"/>
            <div>
              <div class="text-body-2">
                <div
                  class="d-flex justify-space-between mt-2"
                >
                  <div class="label">
                    {{ $t('unpaid') }}
                  </div>
                  <div class="value font-weight-bold">
                    {{ s.notPay | priceDisplay }}
                  </div>
                </div>

                <div
                  class="d-flex justify-space-between pt-1"
                >
                  <div class="label">
                    {{ $t('tips') }}
                  </div>
                  <div class="value font-weight-bold">
                    {{ s.tipIncome ? s.tipIncome : 0 | priceDisplay }}
                  </div>
                </div>

                <div
                  class="d-flex justify-space-between pt-1 "
                >
                  <div class="label">
                    {{ $t('todayTotalNotIncludeTips') }}
                  </div>
                  <div class="value font-weight-bold">
                    {{ s.todayTotal ? s.todayTotal : 0 | priceDisplay }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            style="height: 273px"
          >
            <div class="text-subtitle-2 mt-4">
              {{ $t('todayHaveARest') }}
            </div>
          </div>
        </v-card>
      </v-card>
    </div>
    <ik-entity-form
      v-model="showServantDialog"
      :edited-index="activeIndex"
      :model="model"
      :out-side-list="localServantList"
      @need-refresh="reload"
    />
    <nice-dialog v-model="showServantDetailDialog">
      <v-container>
        <page-header>{{ $t('staffWorkDetail') }}</page-header>

        <div
          v-if="activeServant"
          class="px-2"
          elevation="0"
        >
          <div class="d-flex justify-space-between align-center">
            <div class="text-h4 font-weight-bold">
              {{ activeServant.servant.name }}
            </div>
          </div>
          <div
            v-if="activeServant.todayTotal>0"
          >
            <div class="text-body-1 mt-4">
              <div
                v-for="pay in fillPayMethodTotal(activeServant.payMethodTotal,false)"
                :key="pay.id"
                class="d-flex justify-space-between pt-1"
              >
                <div>
                  {{ $t(pay.name) }}
                </div>
                <div>
                  {{ pay.amount | priceDisplay }}
                </div>
              </div>
            </div>
            <v-divider class="my-4"/>
            <div>
              <div class="text-body-1">
                <div
                  class="d-flex justify-space-between mt-2"
                >
                  <div class="label">
                    {{ $t('unpaid') }}
                  </div>
                  <div class="value font-weight-bold">
                    {{ activeServant.notPay | priceDisplay }}
                  </div>
                </div>

                <div
                  class="d-flex justify-space-between pt-1"
                >
                  <div class="label">
                    {{ $t('tips') }}
                  </div>
                  <div class="value font-weight-bold">
                    {{ activeServant.tipIncome ? activeServant.tipIncome : 0 | priceDisplay }}
                  </div>
                </div>

                <div
                  class="d-flex text-h3 justify-space-between pt-1 "
                >
                  <div class="label">
                    {{ $t('todayTotalNotIncludeTips') }}
                  </div>
                  <div class="value font-weight-bold">
                    {{ activeServant.todayTotal ? activeServant.todayTotal : 0 | priceDisplay }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            style="height: 273px"
          >
            <div class="text-subtitle-2 mt-4">
              {{ $t('todayRelax') }}
            </div>
          </div>
        </div>
      </v-container>
    </nice-dialog>
    <nice-dialog
      v-model="showPersonPowerManageDialog"
      color="#eee"
      width="min(700px,max(calc(100vh - 300px),800px))"
    >
      <v-container class="px-6">
        <div class="d-flex align-center">
          <page-header>
            {{ $t('powerEdit') }}
          </page-header>
          <v-spacer/>
          <v-btn
            class="primary"
            elevation="0"
            @click="saveRawAuth"
          >
            {{ $t('save') }}
          </v-btn>
        </div>
        <div class="text-subtitle-2">
          {{ $t('select_one_authority_or') }}
        </div>
        <div class="mt-3 d-flex">
          <div
            v-for="item in defaultPowerButton"
            :key="item.key"
          >
            <v-btn
              class="mr-2"
              elevation="0"
              outlined
              @click="resetPower(item)"
            >
              {{ $t(item.label) }}
            </v-btn>
          </div>
        </div>
        <div class="text-subtitle-2 mt-6">
          {{ $t('powerRules') }}
        </div>
        <v-btn
          class="mr-2 mt-2"
          elevation="0"
          outlined
          @click="openTreeviewAll"
        >
          {{ $t('openAllPower') }}
        </v-btn>
        <div
          class="mt-2"
          style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 12px"
        >
          <template>
            <v-treeview
              ref="openFrontAll"
              v-model="powerFrontNumber"
              :items="powerFront"
              activatable
              item-key="id"
              open-all
              return-object
              selectable
            />
          </template>
          <template>
            <v-treeview
              ref="openBackendAll"
              v-model="powerBackendNumber"
              :items="powerBackend"
              activatable
              item-key="id"
              open-all
              return-object
              selectable
            />
          </template>
        </div>
      </v-container>
    </nice-dialog>
  </v-container>
</template>

<script>
  import GlobalSettings from '@/GlobalSettings'
  import IKUtils from 'innerken-js-utils'
  import { IkEntityForm } from 'metaflow-js'
  import Servant from '../../../model/tableAndPerson/Servant'
  import { printServantSummaryBon } from '@/common/Utlis/api'
  import { today } from 'metaflow-js/EntityFrameWork/DateRepository'
  import { restaurantMenu } from '@/views/dashboard/components/core/navigation'
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import NiceDialog from '@/composable/InK/NiceDialog'
  import { printServantSummaryForToday, servantList } from '@/common/Utlis/umsatzInfo'
  import Payment from '@/model/common/Payment'
  import { showSuccessMessage, sureToDelete } from '@/common/utils'
  import { defaultPowerButton, power } from '@/model/authSetting'

  export default {
    components: {
      NiceDialog,
      PageHeader,
      IkEntityForm,
    },
    data: function () {
      return ({
        mainPageLoading: false,
        openAll: null,
        defaultPowerButton,
        authRaw: [],
        powerBackendNumber: [],
        powerFrontNumber: [],
        personManagePower: {},
        model: Servant,
        dates: [today, today],
        dialog: false,
        loading: false,
        authPanels: restaurantMenu.filter(it => it.title),
        selectedAuth: null,
        activePerson: null,
        showPersonPowerManageDialog: null,
        powerBackend: power.powerBackend,
        powerFront: power.powerFront,

        showServantDialog: null,
        activeIndex: null,
        activeId: null,
        localServantList: [],
        paymentMethodList: [],

        showServantDetailDialog: null,
      })
    },
    computed: {
      ImageRoot () {
        return this.$store.getters.rootUrl + GlobalSettings.servantRoot
      },
      activeServant () {
        return this.localServantList.find(it => it.id === this.activeId)
      },
    },
    async mounted () {
      await this.reload()
    },
    methods: {
      async reload () {
        this.mainPageLoading = true
        this.paymentMethodList = await Payment.getList()
        this.localServantList = await servantList()
        this.mainPageLoading = false
      },
      openTreeviewAll () {
        this.$refs.openFrontAll.updateAll(true)
        this.$refs.openBackendAll.updateAll(true)
      },
      async resetPower (item) {
        this.activePerson.rawAuth = JSON.stringify(item.power)
        let originRawAuth
        try {
          originRawAuth = JSON.parse(this.activePerson.rawAuth)
        } catch (e) {
          originRawAuth = {
            powerFront: [],
            powerBackend: [],
          }
        }
        this.powerBackendNumber = originRawAuth.powerBackend
        this.powerFrontNumber = originRawAuth.powerFront
      },

      changeActiveId (servant, index) {
        if (servant.todayTotal > 0) {
          const id = servant.servant.id

          this.activeId = id
          this.showServantDetailDialog = true
        } else {
          this.editItem(index)
        }
      },

      fillPayMethodTotal (payMethod, withFilter = true) {
        if (withFilter) {
          const filter = (p) => parseInt(p.id) >= 1 && parseInt(p.id) <= 5
          const included = this.paymentMethodList.filter(filter)

          const res = included.map(p => {
            const r = payMethod.find(t => parseInt(t.payMethodId) === parseInt(p.id))
            return {
              name: p._langsname,
              amount: r?.sumTotal ?? 0,
              id: p.id,
            }
          })

          const otherAmount = payMethod
            .filter(p => parseInt(p.payMethodId) > 5 && parseInt(p.payMethodId) !== 9)
            .reduce((amount, i) => {
              amount += parseFloat(i.sumTotal)
              return amount
            }, 0)

          return [...res, {
            name: 'Others',
            amount: otherAmount,
            id: '-1',
          }]
        } else {
          return this.paymentMethodList.filter(p => parseInt(p.id) > 0 && parseInt(p.id) !== 9)
            .map(p => {
              const r = payMethod.find(t => parseInt(t.payMethodId) === parseInt(p.id))
              return {
                name: p._langsname,
                amount: r?.sumTotal ?? 0,
                id: p.id,
              }
            })
        }
      },

      editItem (index) {
        this.activeIndex = index
        this.showServantDialog = true
      },
      async printServantSummary (pw) {
        IKUtils.showLoading()
        await printServantSummaryForToday(pw)
        showSuccessMessage()
      },
      async deleteItem (id) {
        await sureToDelete(async () => {
          await Servant.remove(id)
          showSuccessMessage()
          await this.reload()
        })
      },
      async startPowerManage (item) {
        this.showPersonPowerManageDialog = true
        this.activePerson = item
        let originRawAuth
        try {
          originRawAuth = JSON.parse(this.activePerson.rawAuth)
        } catch (e) {
          originRawAuth = {
            powerFront: [],
            powerBackend: [],
          }
        }
        this.powerBackendNumber = originRawAuth.powerBackend
        this.powerFrontNumber = originRawAuth.powerFront
      },
      async saveRawAuth () {
        const originRawAuth = {
          powerFront: this.powerFrontNumber,
          powerBackend: this.powerBackendNumber,
        }
        this.activePerson.rawAuth = JSON.stringify(originRawAuth)
        await Servant.edit(this.activePerson)
        showSuccessMessage()
        this.showPersonPowerManageDialog = false
      },
      async printAllServantBon () {
        this.loading = true
        const servantArr = (await Servant.getList())
        for (const d of servantArr) {
          await printServantSummaryBon(d.id, this.dates[0], this.dates[1])
        }
        showSuccessMessage()
        this.loading = false
        this.dialog = false
      },
    },
  }
</script>
<style>
.hiddenText {
  display: inline-block;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hiddenText:hover {
  overflow: visible;
}
</style>
